import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import {Stack} from "@mui/material";

import {useDispatch} from "react-redux";

import {changeWorkIssuance} from "../workIssuanceSlice";



export default function WorkIssuanceCalcTabs(props) {
    const [workIssuanceTabValue, setWorkIssuanceTabValue] = React.useState(2);
    // const [workIssuanceTabValue, setWorkIssuanceTabValue] = React.useState([]);

    const dispatchData = useDispatch();


    const handleChange = (event, newValue) => {
        setWorkIssuanceTabValue(newValue);
        if(newValue == 0){
            dispatchData(changeWorkIssuance({
                owedGridState: false,
                obligationGridState: true,
                offsetsGridState: false,
                paymentGridState: false,
                fringeGridState: false,
                taxGridState: false,
                expenseGridState: false,
                requestGridState: false,
                owedAccrualGridState: false,
                obligationAccrualGridState: false,
                offsetsAccrualGridState: false,
                paymentAccrualGridState: false,
                fringeAccrualGridState: false,
                taxAccrualGridState: false,
                expenseAccrualGridState: false,
                requestAccrualGridState: false,
                owedLiabilityGridState: false,
                obligationLiabilityGridState: false,
                offsetsLiabilityGridState: false,
                paymentLiabilityGridState: false,
                fringeLiabilityGridState: false,
                taxLiabilityGridState: false,
                expenseLiabilityGridState: false,
                requestLiabilityGridState: false,
                owedUltimateGridState: false,
                obligationUltimateGridState: false,
                offsetsUltimateGridState: false,
                paymentUltimateGridState: false,
                fringeUltimateGridState: false,
                taxUltimateGridState: false,
                expenseUltimateGridState: false,
                requestUltimateGridState: false,
                clearData: true, fetchProductId: 0

            }));
            console.log("open obligation");
        }
        if(newValue == 1){
            dispatchData(changeWorkIssuance({
                owedGridState: false,
                obligationGridState: false,
                offsetsGridState: true,
                paymentGridState: false,
                fringeGridState: false,
                taxGridState: false,
                expenseGridState: false,
                requestGridState: false,
                owedAccrualGridState: false,
                obligationAccrualGridState: false,
                offsetsAccrualGridState: false,
                paymentAccrualGridState: false,
                fringeAccrualGridState: false,
                taxAccrualGridState: false,
                expenseAccrualGridState: false,
                requestAccrualGridState: false,
                owedLiabilityGridState: false,
                obligationLiabilityGridState: false,
                offsetsLiabilityGridState: false,
                paymentLiabilityGridState: false,
                fringeLiabilityGridState: false,
                taxLiabilityGridState: false,
                expenseLiabilityGridState: false,
                requestLiabilityGridState: false,
                owedUltimateGridState: false,
                obligationUltimateGridState: false,
                offsetsUltimateGridState: false,
                paymentUltimateGridState: false,
                fringeUltimateGridState: false,
                taxUltimateGridState: false,
                expenseUltimateGridState: false,
                requestUltimateGridState: false,
                clearData: true, fetchProductId: 0
            }));
            console.log("open offsets");
        }
        if(newValue == 2){
            dispatchData(changeWorkIssuance({
                owedGridState: true,
                obligationGridState: false,
                offsetsGridState: false,
                paymentGridState: false,
                fringeGridState: false,
                taxGridState: false,
                expenseGridState: false,
                requestGridState: false,
                owedAccrualGridState: false,
                obligationAccrualGridState: false,
                offsetsAccrualGridState: false,
                paymentAccrualGridState: false,
                fringeAccrualGridState: false,
                taxAccrualGridState: false,
                expenseAccrualGridState: false,
                requestAccrualGridState: false,
                owedLiabilityGridState: false,
                obligationLiabilityGridState: false,
                offsetsLiabilityGridState: false,
                paymentLiabilityGridState: false,
                fringeLiabilityGridState: false,
                taxLiabilityGridState: false,
                expenseLiabilityGridState: false,
                requestLiabilityGridState: false,
                owedUltimateGridState: false,
                obligationUltimateGridState: false,
                offsetsUltimateGridState: false,
                paymentUltimateGridState: false,
                fringeUltimateGridState: false,
                taxUltimateGridState: false,
                expenseUltimateGridState: false,
                requestUltimateGridState: false,
                clearData: true, fetchProductId: 0
            }));
            console.log("open owed");
        }
    };

    return (
        <Stack direction="row" spacing={2}>

            <Box sx={{pt: 2,   height: 40, bgcolor: 'background.paper' }}>
                <Tabs value={workIssuanceTabValue} defaultValue={2}
                      onChange={handleChange} >
                    <Tab  label="Obligation" title="ITD obligation calculation results"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                    <Tab  label="Offsets" title="Amounts reducing the amount owed (credits, advances, prepays)"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                    <Tab  label="Owed" title="ITD owed amount, previous credits, previous paid, current owed"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                </Tabs>
            </Box>
        </Stack>
    );
}
